import { useEffect } from 'react';
import YearBlocksHome from './blocks-year-home';

const YearBlocksIndex = () => {

    useEffect(() => {
        document.title = `Year Blocks | Productivity`;
    }, []);

    return (
        <YearBlocksHome />
    )

};

export default YearBlocksIndex;